// Dtos
import { BusinessDto } from "../../api/dtos/Business.dto";

// Domain Models
import { File } from "./File";

export class Business {
  id: number;
  name: string;
  taxId: string;
  websiteUrl: string;
  reviewedBy: number;
  reviewedAt: string;
  verificationStatus: string;
  proofDocument: File | null;
  // The proof document object is private — proofDocument.url identifies it but
  // will not open. This is the short-lived presigned URL to view it with.
  proofDocumentViewUrl: string | null;

  constructor(entity: BusinessDto) {
    this.id = entity.id;
    this.name = entity.name;
    this.taxId = entity.tax_id;
    this.websiteUrl = entity.website_url;
    this.reviewedBy = entity.reviewed_by;
    this.reviewedAt = entity.reviewed_at;
    this.verificationStatus = entity.verification_status;
    this.proofDocument = entity.proof_document
      ? new File(entity.proof_document)
      : null;
    this.proofDocumentViewUrl = entity.proof_document_view_url ?? null;
  }
}
